import React, { useEffect } from 'react';

import { useAppDispatch, useAppSelector } from 'flow/hooks/useRedux';
import { selectFirstConferenceKey } from 'flow/selectors/pbx-selectors';
import { selectOwnUserHasCapabilityVideo } from 'flow/selectors/ExtensionSelectors';
import { reloadConferences } from 'flow/actions/pbx-actions';
import Page from 'flow/components/Setting/Page';
import NewMeetingDropdown from 'flow/components/meeting/NewMeetingDropdown';
import PersonalMeetingRoomButton from 'flow/components/meeting/PersonalMeetingRoomButton';
import TodayMeetingsSection from 'flow/components/meeting/today-meetings/TodayMeetingsSection';

const LandingPageMeetings = () => {
    const dispatch = useAppDispatch();
    const conferenceKey = useAppSelector(selectFirstConferenceKey);
    const hasVideoCapability = useAppSelector(selectOwnUserHasCapabilityVideo);

    // Nothing else fetches `state.pbx.conferences` for this page — without
    // this, a fresh page load here (e.g. a browser refresh) leaves "Your
    // personal meeting room" missing.
    useEffect(() => {
        dispatch(reloadConferences());
    }, [dispatch]);

    return (
        <Page header="meetings.title">
            <div className="flex items-center gap-4">
                {hasVideoCapability && <NewMeetingDropdown />}
                {conferenceKey && (
                    <PersonalMeetingRoomButton conferenceKey={conferenceKey} />
                )}
            </div>
            <TodayMeetingsSection />
        </Page>
    );
};

export default LandingPageMeetings;
